import style from "./style.module.scss";
import banner from "../../img/banner.png";
import bannerSmall from "../../img/banner-small.png";
import fog from "../../img/fog.png";
import {useStore} from "effector-react";
import {$store} from "../../store";

const Banner = () => {

	const store = useStore($store);

	return (
		<div className={style.banner}>
			{
				!store.app.appIsMobile
					? <img src={banner} alt=""/>
					: <img src={bannerSmall} alt=""/>
			}
			<img className={style.fog} src={fog} alt=""/>
		</div>
	);
};

export default Banner;
